import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchableSelectService {
  private closeAllSubject = new Subject<void>();
  closeAll$ = this.closeAllSubject.asObservable();

  closeAllDropdowns(): void {
    this.closeAllSubject.next();
  }
}

